import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import range from 'lodash/range';
import map from 'lodash/map';
import moment from 'moment';
import styles from './DayTimeline.pcss';
class DayTimeline extends React.PureComponent {
    renderTime(hour) {
        if (hour % 4 !== 0) {
            return null;
        }
        const formattedHour = moment().hour(hour).minutes(0).format('LT');
        return /*#__PURE__*/ _jsx("div", {
            className: styles.dailyHoursDistributionAxis__time,
            children: formattedHour
        });
    }
    renderIndicator(index) {
        const distance = `${index / 24 * 100}%`;
        const direction = 'left';
        const style = {
            [direction]: distance
        };
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.dailyHoursDistributionAxis__indicator,
            style: style,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.dailyHoursDistributionAxis__line
                }),
                this.renderTime(index)
            ]
        }, index);
    }
    renderIndicators() {
        const hours = range(25);
        return map(hours, (index)=>this.renderIndicator(index));
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.dailyHoursDistributionAxis,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.dailyHoursDistributionAxis__inner,
                children: this.renderIndicators()
            })
        });
    }
}
export default withStyles(styles)(DayTimeline);
